import useConfirmService from './useConfirmService'
import Modal from 'src/shared/Modal'
import eventBus from '../eventBus/index'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'

const ConfirmService = () => {
  const { wait, loading } = useHttpLoader()
  const { active, setActive, data } = useConfirmService()

  const handleConfirm = async () => {
    if (data.onConfirm) {
      await wait(data.onConfirm())
    }

    setActive(false)
    eventBus.pub('confirm-service.response', { response: 'confirm' })
  }

  const handleCancel = () => {
    setActive(false)
    eventBus.pub('confirm-service.response', { response: 'cancel' })
  }

  return (
    <Modal
      title={data.title || 'Требуется подтверждение'}
      onClose={handleCancel}
      closeOnClickOutside={false}
      open={active}
    >
      <div style={{ marginBottom: '12px' }}>
        <p className="text--body-m text-pre">{data.description || 'Вы действительно хотите удалить вид?'}</p>
      </div>
      <div className="inline-flex-gap gap8 width100" style={{ justifyContent: 'flex-end' }}>
        <Button size="default" type="default" text="Отмена" onClick={handleCancel} disabled={loading} />
        <Button
          size="default"
          loading={loading}
          type="primary"
          text={data.confirmText || 'Удалить'}
          onClick={handleConfirm}
        />
      </div>
    </Modal>
  )
}

export default ConfirmService
